'use strict';

import Vue from "vue";
import VeeValidate from "vee-validate";
import skDictionary from "./sk";
import decimalValidator from "./decimalValidator";
import minValueValidator from "./minValueValidator";
import numericValidator from "./numericValidator";

export default () => {

  const config = {
    locale: 'sk',
    inject: false,
    dictionary: {
      sk: {
        messages: skDictionary
      }
    }
  };

  Vue.use(VeeValidate, config);
}



// WEBPACK FOOTER //
// ./client/validation/index.js